// extracted by mini-css-extract-plugin
export default {"gallery":"S3Qg9","slide":"Ox6M3"};